import dynamic from "next/dynamic";
import RemoteWorkFooterConfig from "./remote-work-footer-config";
import RemoteWorkFooterAdvancedConfig from "./remote-work-footer-advanced-config";
const RemoteWorkFooterComponent = dynamic(()=>import("./remote-work-footer-component"));
export default {
    RemoteWorkFooterComponent,
    RemoteWorkFooterConfig,
    RemoteWorkFooterAdvancedConfig
};
